import { SunnyRequestBuilder } from '@/models/Common/SunnyRequestBuilder';
import { IPolicyAPIRequestParams } from '@/models/PolicyAPI/interfaces/IPolicyAPIRequestParams';
import PolicyAPIJSC from '@/schema/PolicyAPIJSC';
import { IRequestWrap } from '@/server/IServer';
import { TReqConfigValidated } from '@/services/JSCService';
import { defaultTo } from 'ramda';

export class PolicyAPIClientRequestBuilder extends SunnyRequestBuilder {
  createPolicyQuery(reqParams: IPolicyAPIRequestParams): TReqConfigValidated {
    return this.validate(PolicyAPIJSC, reqParams).map((params) => this.makeConfig('GET', '/policy-api', params));
  }
}

export class PolicyAPIRequestBuilder extends SunnyRequestBuilder {
  protected makeHeaders = defaultTo({});

  createPolicyQuery(reqParams: IPolicyAPIRequestParams): TReqConfigValidated {
    const endpointBuilder = (url: string): string => `${this.baseURI.href()}/${url}`;
    return this.validate(PolicyAPIJSC, reqParams).map((params) =>
      this.makeConfig('GET', reqParams.query.path, params, {}, endpointBuilder),
    );
  }

  static getBaseURIFromReq(req: IRequestWrap): URI {
    return req.config.PolicyAPI;
  }
}
